var module = angular.module('octopusApp.shared');

module.directive('interruptionForm', function (octoDialog) {
  return {
    restrict: 'E',
    replace: true,
    transclude: false,
    scope: {
      interruptions: '=',
      submitted: '=',
      takeResponsibility: '=',
      isSubmitting: '=',
      correlateLog: '='
    },
    templateUrl: 'areas/shared/views/interruption-form.html',
    link: function ($scope, element, attrs) {
      $scope.interruptionsModel = new Octopus.Model.SynchronizedList({
        sourceToTargetTransformer: function (a) {
          var instance = {};
          instance.title = a.Title;
          instance.elements = [];
          instance.value = null;
          instance.isPending = a.IsPending;
          instance.isMine = a.HasResponsibility;
          instance.isUnassigned = !instance.isMine && !a.ResponsibleUserId;
          instance.isAssignedToSomeoneElse = !instance.isMine && a.ResponsibleUserId;
          instance.couldBeMine = a.CanTakeResponsibility;
          instance.original = a;
          instance.responsibleUserId = a.ResponsibleUserId;
          instance.correlationId = a.CorrelationId;
          instance.isOpen = instance.isMine;
          instance.toggleOpen = function() {
            instance.isOpen = !instance.isOpen;
          };

          _.each(a.Form.Elements, function(element) {
            instance.elements.push({
              label: element.Name,
              name: element.Name,
              type: element.Control.Type,
              interrupt: instance,
              required: element.IsValueRequired,
              properties: element.Control
            });
          });

          return instance;
        },
        refresh: function(instance, a) {
          instance.isPending = a.IsPending;
          instance.isMine = a.HasResponsibility;
          instance.isUnassigned = !instance.isMine && !a.ResponsibleUserId;
          instance.isAssignedToSomeoneElse = !instance.isMine && a.ResponsibleUserId;
          instance.couldBeMine = a.CanTakeResponsibility;
          instance.responsibleUserId = a.ResponsibleUserId;
          instance.original = a;
          if (instance.isMine) {
            instance.isOpen = true;
          }
        },
        sourceKey: function (a) {
          return a.Id;
        },
        onAdded: function(a) { },
        onRemoved: function(a) { }
      });

      $scope.$watch('interruptions', function () {
        $scope.interruptionsModel.sync($scope.interruptions);
      });

      $scope.submit = function(submittingElement, value, requiresConfirmation) {
        if (requiresConfirmation) {
          octoDialog.messageBox(
              "Confirm " + value,
              "Are you sure you want to " + value + "?",
              [{
                result: 'yes',
                label: 'Yes',
                cssClass: 'btn-success'
              }, {
                result: 'cancel',
                label: 'Cancel'
              }]).then(function (result) {
                if (result === 'yes') {
                  submitResult(submittingElement, value);
                }
              });
        }
        else {
          submitResult(submittingElement, value);
        }
      };

      function submitResult(submittingElement, value) {
        var result = {};
        _.each(submittingElement.interrupt.elements, function (element) {
          result[element.name] = element.value;
          if (!result[element.name]) {
            result[element.name] = '';
          }
        });

        result[submittingElement.name] = value;

        $scope.submitted(submittingElement.interrupt.original, result);
      }

      $scope.confirmTakeResponsibility = function(interrupt) {

        octoDialog.messageBox(
            "Confirm re-assignment",
            "Someone else is already assigned to this interruption. Are you sure you wish to assign it to yourself?",
            [{
              result: 'yes',
              label: 'Yes',
              cssClass: 'btn-success'
            }, {
              result: 'cancel',
              label: 'Cancel'
            }]).then(function (result) {
              if (result === 'yes') {
                $scope.takeResponsibility(interrupt);
              }
            });
      };
    }
  };
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/shared/directives/interruption_form.js
// module id = 5666460859744248
// module chunks = 1